import React from 'react'

export default function CronYearOptions({ properties, setProperties }) {
    return (
        <>
            <div className='col-3'>
                <select
                    defaultValue={properties && properties.yearOccourance}
                    onChange={(e) => setProperties({ ...properties, yearOccourance: e.target.value })
                    }
                    className='form-control form-control-sm'><option></option>
                    <option selected={properties.yearOccourance === 'Every Year'}>Every Year</option>
                    <option selected={properties.yearOccourance === 'Specific Year'}>Specific Year</option>
                </select>
            </div>
            <div className='col-3'>
                {
                    properties.yearOccourance === 'Specific Year'
                        ?
                        <input
                            defaultValue={properties && properties.yearWhen}
                            onChange={(e) => setProperties({ ...properties, yearWhen: e.target.value })}
                            className='flex-grow-1 form-control form-control-sm' type='number'
                        />
                        : <></>
                }

            </div>
        </>
    )
}
